import { PlayWindow } from "../../api";
import { Rect, Size } from "../../MyHelpers";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { Settings } from "../../Settings";
import { AnticipacionPIXIAPP } from "../AnticipacionPIXIAPP";
import { AnticipationType, defaultGameConfig, GameConfigurationJson } from "../SpineSymbols/SymbolsCollection";
import * as PIXI from "pixi.js";
import { AnticipationDefault } from "./AnticipationDefault";

export interface IAnticipation extends Resourceful {
    Create(reelPositon: Rect[], windowRectangle: Rect):void;
    GetView(): PIXI.Container;
    Destroy():void;
    ShowReelAnimation(index: number):void;
    HideReelAnimation(index: number):void;
}
export interface IAnticipationFactoryParams{
    playWindow : PlayWindow;
    symbolSize : Size;
    gameName : string;
    anticipationType: AnticipationType;
}

export interface AnticipationParams{
    playWindow : PlayWindow;
    symbolSize : Size;
    gameName : string;
}


export class AnticipationFactory{

    protected params: AnticipationParams = null;
    protected internalParams: IAnticipationFactoryParams = null;

    public constructor(params: IAnticipationFactoryParams) {
        
        this.internalParams ={
            playWindow : params.playWindow,
            symbolSize : params.symbolSize,
            gameName : params.gameName,
            anticipationType: params?.anticipationType ?? defaultGameConfig.anticipationType,
        }

    }

    public CreateAnticipation(): IAnticipation {
        
        this.params ={
            playWindow : this.internalParams.playWindow,
            symbolSize : this.internalParams.symbolSize,
            gameName : this.internalParams.gameName,
        }

        const anticipation = AnticipationFactoryMap[this.internalParams.anticipationType](this.params);
        return anticipation;
    }

}

type anticipationFactoryCallback = (params: AnticipationParams) => AnticipationDefault;
const AnticipationFactoryMap: Record<AnticipationType, anticipationFactoryCallback> = {
    [AnticipationType.Spine]: (params: AnticipationParams) => new AnticipacionPIXIAPP(params.playWindow, params.symbolSize, params.gameName),
    [AnticipationType.None]: (_) => null,
}